import { useTranslation } from "react-i18next";
import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
} from "@certn/cascadia-react";

export function LocationCountryWhatsThis() {
  const { t } = useTranslation();
  return (
    <DialogTrigger>
      <LinkButton testID="" textStyle="form/body-secondary-link">
        {t("What's this?")}
      </LinkButton>
      <Popover placement="top right">
        <PopoverContent>
          {t(
            "Location Country helps determine the country in which the user is primarily operating. This setting is used to control access and permissions, ensuring users only view data permitted for their region."
          )}
        </PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
